var map = {
	"./arrow.svg": 6026,
	"./building.svg": 7223,
	"./calendar.svg": 5077,
	"./chevron--double.svg": 6537,
	"./chevron.svg": 872,
	"./clock.svg": 8303,
	"./district/de-aker.svg": 4147,
	"./district/geuzenveld.svg": 5039,
	"./district/nieuw-west-midden.svg": 8426,
	"./district/osdorp-west.svg": 9477,
	"./district/sloten-en-nieuw-sloten.svg": 5760,
	"./district/slotermeer-oost.svg": 7160,
	"./district/slotermeer-west.svg": 4406,
	"./district/slotervaart-noord.svg": 6440,
	"./district/slotervaart-zuid.svg": 6914,
	"./email.svg": 8157,
	"./instagram.svg": 4849,
	"./linkedin.svg": 9093,
	"./loading.svg": 7293,
	"./location.svg": 7050,
	"./logo-gemeente_amsterdam.svg": 6496,
	"./logo-grote_speler--full--black.svg": 6898,
	"./logo-grote_speler--full.svg": 2367,
	"./logo-grote_speler--icon.svg": 9531,
	"./logo-jongerenpunt.svg": 1820,
	"./mail.svg": 3810,
	"./minus.svg": 3541,
	"./pause.svg": 1791,
	"./phone.svg": 2661,
	"./play.svg": 905,
	"./plus.svg": 5143,
	"./quote-cloud.svg": 7089,
	"./refresh.svg": 5068,
	"./social_wall-arrows-long.svg": 1087,
	"./social_wall-arrows.svg": 5156,
	"./whatsapp.svg": 2013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5312;